import React from "react";
import styles from "./StepSubscription.module.scss";
import { FaUserAlt, FaHashtag } from "react-icons/fa";
import InputForms from "components/UiComponents/forms/InputForms";


const StepSubscription = ({ userData, updateUserData, onNext, onPrev }) => {

    return (
        <div className={styles.container}>

            <InputForms
                type="text"
                placeholder="Libellé"
                value={userData.subscription}
                onChange={(e) => updateUserData({ subscription: e.target.value })}
                required
                svg={<FaUserAlt />}
            />
            <InputForms
                type="text"
                placeholder="N° Odoo"
                value={userData.subid}
                onChange={(e) => updateUserData({ subid: e.target.value })}
                required
                svg={<FaHashtag />}
            />

            <select
                value={userData.plan}
                onChange={(e) => updateUserData({ plan: e.target.value })}
            >
                <option value="std">Standard</option>
                <option value="pro">Pro</option>
            </select>

        </div>
    );
};

export default StepSubscription;
